<template>
	<div class="form-overlay">
		<i @click="hideFormOverlay" class="form-overlay__close" />
		<legend class="form-overlay__legend">
			Wprowadź dane swojej firmy,<br />
			żeby wygenerować ofertę
		</legend>

		<label class="form-overlay__label" for="companyName">Nazwa firmy</label>
		<input
			id="companyName"
			type="text"
			required
			v-model="companyName"
			:disabled="status === 'pending'"
			class="topbar__input form-overlay__input"
		/>
		<label class="form-overlay__label" for="address">Adres</label>
		<input
			id="address"
			type="text"
			required
			v-model="address"
			:disabled="status === 'pending'"
			class="topbar__input form-overlay__input"
		/>
		<label class="form-overlay__label" for="nip">NIP</label>
		<input
			id="nip"
			type="text"
			required
			pattern="[0-9]{10}"
			v-model="nip"
			:disabled="status === 'pending'"
			class="topbar__input form-overlay__input"
		/>

		<div v-if="status === 'pending'">Generowanie...</div>
		<div v-if="status === 'success'" class="success">Oferta wygenerowana pomyślnie!</div>
		<div v-if="status === 'error'" class="error">{{ error }}</div>

		<SubmitConfiguration
			isDownloadEnabled
			isPartnerArea
			:companyName="companyName"
			:address="address"
			:nip="nip"
		/>
	</div>
</template>

<script>
import {formatPrice} from '../../common/helpers/format-price';
import {api} from '../core/services/api';
import SubmitConfiguration from './SubmitConfiguration';

export default {
	name: 'GenerateConfiguration',
	components: {SubmitConfiguration},
	data() {
		return {
			// possible statuses: editing, pending, success, error
			status: 'editing',
			companyName: null,
			address: null,
			nip: null,
			error: null,
		};
	},
	methods: {
		hideFormOverlay() {
			this.companyName = null;
			this.nip = null;
			this.address = null;

			this.$store.commit('M_SET_APP_STATE', {
				isConfigurationFormOverlayVisible: false,
			});
		},
	},
	mounted() {},
};
</script>
